import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
import "./index.css";
// KTK-211 — Agent V2 chat surface theme tokens. Scoped under
// `[data-agent-v2]` so the OKLCH palette only resolves inside an
// AgentV2ChatView and doesn't disturb the rest of the app's CSS vars.
import "@kritaka/ui/agent-v2/theme.css";

// Forces Vite to mint a fresh bundle hash on this deploy. The prior bundle's
// hash-pinned URL got poisoned in CF's edge cache (served text/html instead
// of application/javascript) during a deploy race; rolling the hash puts
// index.html on a filename that CF hasn't cached yet. Assigning the tag
// onto `window` keeps the minifier from dead-code-eliminating it so the
// bundle genuinely changes byte-wise. Safe to remove once we've confirmed
// the _redirects guard below prevents recurrences.
(globalThis as { __kritakaBuildTag?: string }).__kritakaBuildTag =
  "2026-04-22-cache-bust";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("#root missing from index.html");

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
